export default "__VITE_ASSET__vJew1R$p__"